/**
 * Normalización de fabricantes para iconografía (Sprint 286 D; diseño §3).
 * `publisher` del catálogo (`ModelCatalogEntry.publisher`) → slug estable.
 */

/** Mapa de variantes conocidas → slug canónico del fabricante. */
const PUBLISHER_ALIASES: Record<string, string> = {
  'openai inc': 'openai',
  'open ai': 'openai',
  'anthropic pbc': 'anthropic',
  'google deepmind': 'google',
  'google vertex': 'google',
  'meta ai': 'meta',
  'meta llama': 'meta',
  'mistral ai': 'mistral',
  'deepseek ai': 'deepseek',
  'x ai': 'xai',
  'alibaba cloud': 'qwen',
};

export function publisherSlug(publisher?: string | null): string {
  if (!publisher) return '';
  const normalized = publisher
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
  return PUBLISHER_ALIASES[normalized] ?? normalized.replace(/\s+/g, '-');
}
